var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { translateSync } from "@opendash/i18n";
import { Modal } from "antd";
import { makeAutoObservable, runInAction } from "mobx";
import { Workbox } from "workbox-window";
export class ServiceWorkerService {
    constructor(framework) {
        this.wb = null;
        this.updatePromise = null;
        this.updateResolver = null;
        this.updateForce = false;
        this.updateAvailable = false;
        this.updateLoading = false;
        makeAutoObservable(this);
        this.framework = framework;
    }
    init(active) {
        if (active) {
            this.registerServiceWorker();
        }
        else {
            this.removeServiceWorkers();
        }
    }
    registerServiceWorker(path = "/service-worker.js") {
        try {
            if (this.wb) {
                return void console.error(`[@opendash/core] $framework.serviceWorker.registerServiceWorker() was called twice.`);
            }
            if ("serviceWorker" in navigator) {
                this.wb = new Workbox(path);
                this.wb.addEventListener("waiting", (event) => {
                    runInAction(() => {
                        this.updateAvailable = true;
                    });
                });
                this.wb.addEventListener("controlling", (event) => {
                    runInAction(() => {
                        this.updateLoading = false;
                    });
                    if (this.updateResolver) {
                        this.updateResolver();
                    }
                    this.updatePromise = null;
                    this.updateResolver = null;
                    if (this.updateForce) {
                        window.location.reload();
                    }
                    else {
                        this.confirmUpdateDialog();
                    }
                });
                this.wb.register();
            }
        }
        catch (error) {
            console.error("No service worker", error);
        }
    }
    installUpdate(force) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.updatePromise) {
                return this.updatePromise;
            }
            this.updateForce = !!force;
            this.updatePromise = new Promise((resolve) => {
                runInAction(() => {
                    this.updateResolver = resolve;
                    this.updateLoading = true;
                });
                if (this.wb && this.updateAvailable) {
                    this.wb.messageSW({ type: "SKIP_WAITING" });
                }
                else {
                    resolve();
                }
            });
            return this.updatePromise;
        });
    }
    installUpdateDialog() {
        Modal.confirm({
            title: translateSync("opendash:ui.version_update_dialog_title"),
            content: translateSync("opendash:ui.version_update_dialog_description"),
            icon: false,
            okText: translateSync("opendash:ui.install"),
            cancelText: translateSync("opendash:ui.cancel"),
            onOk: () => this.installUpdate(),
        });
    }
    confirmUpdateDialog() {
        Modal.confirm({
            title: translateSync("opendash:ui.version_install_dialog_title"),
            content: translateSync("opendash:ui.version_install_dialog_description"),
            icon: false,
            okText: translateSync("opendash:ui.ok"),
            cancelText: translateSync("opendash:ui.cancel"),
            onOk: () => void window.location.reload(),
        });
    }
    removeServiceWorkers() {
        if ("serviceWorker" in navigator) {
            navigator.serviceWorker.getRegistrations().then(function (registrations) {
                for (const registration of registrations) {
                    registration.unregister();
                }
            });
        }
    }
}
//# sourceMappingURL=ServiceWorkerService.js.map